var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMountain = function SvgMountain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 5.536a5.08 5.08 0 0 0-4.595 2.91L3.87 32.797A1.25 1.25 0 0 0 5 34.583h30a1.25 1.25 0 0 0 1.13-1.785L24.595 8.445A5.08 5.08 0 0 0 20 5.536m-1.382 2.9a2.583 2.583 0 0 1 3.717 1.079l4.473 9.444q-.045.03-.089.065l-3.102 2.481-2.577-3.865a1.25 1.25 0 0 0-1.924-.19l-3.179 3.178-2.221-2.776 3.949-8.337c.21-.443.54-.816.953-1.078m-6.093 11.93-5.55 11.717h26.05l-5.12-10.807-3.79 3.033a1.25 1.25 0 0 1-1.822-.283l-2.487-3.73-3.089 3.088a1.25 1.25 0 0 1-1.86-.103z",
    clipRule: "evenodd"
  })));
};
export default SvgMountain;